import { getDefaultExportFromCjs } from "../../../_virtual/_commonjsHelpers.js";
import { __exports as dist } from "../../../_virtual/index.js";
import "./ScrollLock.js";
import "./TouchScrollable.js";
import { __exports as TouchScrollable } from "../../../_virtual/TouchScrollable.js";
import { __exports as ScrollLock$1 } from "../../../_virtual/ScrollLock.js";
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _ScrollLock = ScrollLock$1;
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_ScrollLock).default;
    }
  });
  var _TouchScrollable = TouchScrollable;
  Object.defineProperty(exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
      return _TouchScrollable.TouchScrollable;
    }
  });
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
})(dist);
const ScrollLock = /* @__PURE__ */ getDefaultExportFromCjs(dist);
export {
  ScrollLock as default
};
//# sourceMappingURL=index.js.map
